import RosterIdentityRosterQrAssignment from './RosterIdentityRosterQrAssignment';

export default RosterIdentityRosterQrAssignment;
